import { call, put, takeEvery, select, fork } from "redux-saga/effects"
import { toast } from "react-toastify"
// Crypto Redux States
import InspectionType from "./actionTypes"

import InspectionAction from "./actions"
import moment from "moment"
import InspectionAPI from "helpers/inspection_backend_helper"
import debounce from "debounce-promise"

let debouncedFetchOrderList = debounce(InspectionAPI.getOrderList, 1000)
let debouncedFetchOrderRTW = debounce(InspectionAPI.getRtwOrderList, 1000)

function* getOrderList({ payload }) {
  yield put(
    InspectionAction.getOrderListSuccess({
      loading: true,
      data: [],
    })
  )
  try {
    let { data } = yield call(debouncedFetchOrderList, payload)
    yield put(
      InspectionAction.getOrderListSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      InspectionAction.getOrderListSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* getRtwOrderList({ payload }) {
  yield put(
    InspectionAction.getRtwOrderListSuccess({
      loading: true,
      data: [],
    })
  )
  try {
    let { data } = yield call(debouncedFetchOrderRTW, payload)
    yield put(
      InspectionAction.getRtwOrderListSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    console.log(error)
    yield put(
      InspectionAction.getRtwOrderListSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* getOrderDetail({ payload, action }) {
  yield put(
    InspectionAction.getOrderDetailSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(InspectionAPI.getOrderDetail, payload)

    action(data)
    yield put(
      InspectionAction.getOrderDetailSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    console.log(error)
    yield put(
      InspectionAction.getOrderDetailSuccess({
        loading: false,
        data: {},
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* getRtwOrderDetail({ payload, action }) {
  yield put(
    InspectionAction.getRtwOrderDetailSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(InspectionAPI.getRtwOrderDetail, payload)

    action(data)
    yield put(
      InspectionAction.getRtwOrderDetailSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    console.log(error)
    yield put(
      InspectionAction.getRtwOrderDetailSuccess({
        loading: false,
        data: {},
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* getOrderDetailSize({ payload, action }) {
  yield put(
    InspectionAction.getOrderDetailSizeSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(InspectionAPI.getOrderSizeDetail, payload)

    action(data)
    yield put(
      InspectionAction.getOrderDetailSizeSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    console.log(error)
    yield put(
      InspectionAction.getOrderDetailSizeSuccess({
        loading: false,
        data: {},
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* getRtwOrderDetailSize({ payload, action }) {
  yield put(
    InspectionAction.getRtwOrderDetailSizeSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(InspectionAPI.getRtwOrderSizeDetail, payload)

    action(data)
    yield put(
      InspectionAction.getRtwOrderDetailSizeSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    console.log(error)
    yield put(
      InspectionAction.getRtwOrderDetailSizeSuccess({
        loading: false,
        data: {},
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* postOrderData({ payload, action }) {
  yield put(
    InspectionAction.postOrderDataSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(InspectionAPI.postOrderData, payload)

    yield put(
      InspectionAction.postOrderDataSuccess({
        loading: false,
        data,
      })
    )
    action()
  } catch (error) {
    console.log(error)
    toast.error(error.response.data?.message)
    yield put(
      InspectionAction.postOrderDataSuccess({
        loading: false,
        data: {},
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* postRtwOrderData({ payload, action }) {
  yield put(
    InspectionAction.postRtwOrderDataSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(InspectionAPI.postRtwOrderData, payload)

    yield put(
      InspectionAction.postRtwOrderDataSuccess({
        loading: false,
        data,
      })
    )
    action()
  } catch (error) {
    console.log(error)
    toast.error(error.response.data?.message)

    yield put(
      InspectionAction.postRtwOrderDataSuccess({
        loading: false,
        data: {},
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* patchDefect({ payload, action }) {
  yield put(
    InspectionAction.patchDefectSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(InspectionAPI.patchDefect, payload)

    yield put(
      InspectionAction.patchDefectSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    console.log(error)
    yield put(
      InspectionAction.patchDefectSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* postOrderMemo({ payload, action }) {
  yield put(
    InspectionAction.postOrderMemoSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(InspectionAPI.postOrderMemo, payload)

    yield put(
      InspectionAction.postOrderMemoSuccess({
        loading: false,
        data,
      })
    )
    action()
  } catch (error) {
    console.log(error)
    toast.error(error.response.data?.message)
    yield put(
      InspectionAction.postOrderMemoSuccess({
        loading: false,
        data: {},
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* postRtwOrderMemo({ payload, action }) {
  yield put(
    InspectionAction.postRtwOrderMemoSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(InspectionAPI.postRtwOrderMemo, payload)

    yield put(
      InspectionAction.postRtwOrderMemoSuccess({
        loading: false,
        data,
      })
    )
    action()
  } catch (error) {
    console.log(error)
    toast.error(error.response.data?.message)

    yield put(
      InspectionAction.postRtwOrderMemoSuccess({
        loading: false,
        data: {},
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* inspectionSaga() {
  yield takeEvery(InspectionType.GET_INSPECTION_ORDER_LIST, getOrderList)
  yield takeEvery(InspectionType.GET_INSPECTION_RTW_ORDER_LIST, getRtwOrderList)
  yield takeEvery(InspectionType.GET_INSPECTION_DETAIL_ORDER, getOrderDetail)
  yield takeEvery(
    InspectionType.GET_INSPECTION_DETAIL_RTW_ORDER,
    getRtwOrderDetail
  )
  yield takeEvery(
    InspectionType.GET_INSPECTION_DETAIL_ORDER_SIZE,
    getOrderDetailSize
  )
  yield takeEvery(
    InspectionType.GET_INSPECTION_DETAIL_RTW_ORDER_SIZE,
    getRtwOrderDetailSize
  )
  yield takeEvery(InspectionType.POST_ORDER, postOrderData)
  yield takeEvery(InspectionType.POST_RTW_ORDER, postRtwOrderData)
  yield takeEvery(InspectionType.PATCH_DEFECT, patchDefect)

  yield takeEvery(InspectionType.POST_ORDER_MEMO, postOrderMemo)
  yield takeEvery(InspectionType.POST_RTW_ORDER_MEMO, postRtwOrderMemo)
}

export default inspectionSaga
